<template>
  <div>
    <div v-if="showReport">
      <QualityReport :score="score" :image="image" v-on:listenToChildEvent="handlePlayAgain"></QualityReport>
    </div>
    <div v-if="closeReport">
      <Quality v-on:listenToChildEvent="handlQuality"></Quality>
    </div>
  </div>
</template>

<script>
  import Quality from '@/page/Quality.vue'
  import QualityReport from '@/page/QualityReport.vue'
  import axios from 'axios';
  import qs from 'qs';
  import { mapState } from 'vuex'
  export default{
    components: {
      'Quality':Quality,
      'QualityReport':QualityReport,
    },
    data(){
      return{
        closeReport:true,
        showReport:false,
        score:0,
        image:'',
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },
    created(){
      this.getReport()
    },
    methods:{
      // 获取素质库报告
      getReport(res){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosTreaAbilityReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data;
             if(Result){
               this.score = Result.cosTreaAbility.totalScore,
               this.image = Result.cosTreaAbility.image+ '?' + new Date().getTime()
               this.closeReport =false
               this.showReport = true
             }
          }else{
            this.$store.commit('showMessage', {
              message: response.data.result.message,
              type: 'error'
            })
          }
        })
        .catch((error)=>{
          console.warn(error);
        })
      },
      handlePlayAgain(type){
        if(type=='play-again'){
          this.closeReport =true
          this.showReport = false
        }else{
          this.$emit("listenToChildEvent")
        }
      },
      handlQuality(){
        this.getReport()
      },
    }
  }
</script>

<style>
</style>
